import { createSelector } from '@ngrx/store';
import { getOverviewState, OverviewState } from '../registration';
import { DepotState } from '../reducers';

export const getDepotsState = createSelector(getOverviewState, (state: OverviewState) => state.depots);
export const getSelectedDepotUnloadActionIds = createSelector(
  getDepotsState,
  (state: DepotState) => state.selectedDepotUnloadActionIds
);
